// recon-bank-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rcb.match.matched': 'Matched to booking',
  'rcb.match.suggested': 'Suggested match',
  'rcb.match.review': 'For manual review',
  'rcb.match.unmatchedBank': 'Unmatched bank transaction',
  'rcb.match.manual': 'Added manually',
  'rcb.match.excluded': 'Kept out',
  'rcb.match.noBankMatch': 'Booking without bank match',
  'rcb.status.new': 'Not processed',
  'rcb.status.suggested': 'Suggestion pending',
  'rcb.status.review': 'For review',
  'rcb.status.booked': 'Booked',
  'rcb.status.approved': 'Approved',
  'rcb.status.private': 'Private',
  'rcb.status.operating': 'Business',
  'rcb.status.ignored': 'Ignored',
  'rcb.status.manual': 'Added manually',
  'rcb.line.fallback': 'Bank line',
  'rcb.source.private': 'Private account',
  'rcb.source.statement': 'Bank statement',
  'rcb.source.none': 'No statement',
  'rcb.cov.none': 'No bank statement for the period',
  'rcb.cov.missingRange': 'missing from {from} to {to}',
  'rcb.cov.and': '{first} and {second}',
  'rcb.check.coverage': 'The bank data covers the whole period',
  'rcb.check.balance': 'Booked balance matches bank balance',
  'rcb.check.notBooked': 'All bank lines are booked',
  'rcb.check.review': 'No lines are awaiting manual review',
  'rcb.check.missingVoucher': 'Payments have vouchers',
  'rcb.check.duplicate': 'Possible duplicates have been assessed',
  'rcb.check.noBankMatch': 'All bookings on the bank accounts have a bank line',
  'rcb.check.staleTransit': 'No old bookings are waiting for the bank',
  'rcb.check.internal': 'Internal transfers balance',
});
